<template>
  <nav
    :class="['navbar navbar-expand-lg navbar-dark bg-dark content-fluid pb-3', { 'scrolled': isScrolled, 'fixed-top': screenWidth > 600, 'sticky-top': screenWidth <= 600 }]">
    <div class="container-fluid navbar-custom">
      <router-link class="navbar-brand" to="/">
        <img class="vectorFriax iconNavbar desktop d-none d-lg-block" alt=""
          src="../../../public/assets/images/logos/FriaxLogo.svg" />
        <img class="vectorFriax iconNavbar d-xl-none d-lg-none d-block" alt=""
          src="../../../public/assets/images/logos/friaxAzul.svg" />
      </router-link>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <img alt="" src="../../../public/assets/images/logos/menu.svg" />
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link :class="{ 'nav-link': true, 'active': isActive('/') }" aria-current="page"
              to="/">INICIO</router-link>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              PROYECTO
              <i class="fas fa-arrow-down ms-2"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><router-link :class="{ 'dropdown-item': true, 'active': isActive('/terranova') }"
                  to="/terranova">TERRANOVA</router-link></li>
              <li><router-link :class="{ 'dropdown-item': true, 'active': isActive('/norterra') }"
                  to="/norterra">NORTERRA</router-link></li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link :class="{ 'nav-link': true, 'active': isActive('/contacto') }" aria-current="page"
              to="/contacto">CONTACTO</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { inject } from 'vue';

export default defineComponent({
  name: 'MenBar',
  setup() {
    const screenWidth = inject('screenWidth');
    const route = useRoute();
    const isScrolled = ref(false);

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50;
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    watch(isScrolled, (newValue) => {
      console.log(newValue);
      if (newValue) {
        document.querySelector('.navbar').classList.add('scrolled');
      } else {
        document.querySelector('.navbar').classList.remove('scrolled');
      }
    });

    const isActive = (path) => {
      return route.path === path;
    };

    return {
      isActive,
      screenWidth,
      isScrolled
    };
  }
});
</script>

<style scoped>
/* Estilo personalizado para el enlace activo */
.navbar.scrolled {
  background-color: rgba(0, 0, 0, 0.8) !important;
  /* Negro con 80% de opacidad */
  transition: background-color 0.3s;
}
</style>